<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div [ngSwitch]="screen">
                    <div *ngSwitchCase="0"></div>
                    <div *ngSwitchCase="1">
                        <div class="row">
                            <span class="modal-sub-header">Options: </span>
                            <div [hidden]="version !== 'MAR/TAR'">
                                <label class="checkbox" ><input type="checkbox" (change)="selectBlank()" [checked]="marOptions.MedicalRecord === blankValue"><span></span>
                                    <span class="checkbox-label">Blank Forms</span>
                                </label>
                            </div>
                        </div>
                        <div class="row" [hidden]="version !='MAR/TAR'">
                            <span class="modal-sub-header">Select records to include: <span class="modal-sub-header" style="margin-left: 10px;"><a (click)="selectMarTar()" [hidden]="marOptions.MedicalRecord === blankValue">Select All</a></span></span>
                            <div>
                                <label class="checkbox"><input type="checkbox" (change)="selectMar()" [checked]="marOptions.MedicalRecord === marValue || marOptions.MedicalRecord === marTarValue" [disabled]="blankForm"><span></span>
                                    <span class="checkbox-label {{blankForm ? 'disabled' : ''}}">Medical Administration Record (MAR)</span>

                                </label>
                            </div>
                            <div>
                                <label class="checkbox"><input type="checkbox" (change)="selectTar()" [checked]="marOptions.MedicalRecord === tarValue || marOptions.MedicalRecord === marTarValue" [disabled]="blankForm"><span></span>
                                    <span><span class="checkbox-label {{blankForm ? 'disabled' : ''}}">Treatment Authorization Request (TAR) </span></span>
                                </label>
                            </div>
                        </div>
                        <div class="row" [hidden]="version !='MAR/TAR' || marOptions.MarGroups.length === 0">
                            <span class="modal-sub-header">MAR Group Options: <span class="modal-sub-header" style="margin-left: 10px;"><a (click)="selectAllMarOptions()" [hidden]="marOptions.MedicalRecord === blankValue">Select All</a></span></span>
                            <div *ngFor="let option of marOptions.MarGroups">
                                <label class="checkbox"><input type="checkbox" [disabled]="blankForm || !(marOptions.MedicalRecord === marValue || marOptions.MedicalRecord === marTarValue)" [(ngModel)]="option.IsSelected"><span></span>
                                    <span class="checkbox-label {{(blankForm  || !(marOptions.MedicalRecord === marValue || marOptions.MedicalRecord === marTarValue)) ? 'disabled' : ''}}">{{option.Description}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <span class="modal-sub-header"></span>
                            <div *ngFor="let option of marOptions.ReportOptions">
                                <label class="checkbox"><input type="checkbox" [disabled]="blankForm" [(ngModel)]="option.IsSelected"><span></span>
                                    <span class="checkbox-label {{blankForm ? 'disabled' : ''}}">{{option.Description}}</span>
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <span class="modal-sub-header">Effective Date Range:</span><br>
                            <my-date-range-selector
                                    [disabled]="blankForm"
                                    [skipDataStore]="true"
                                    [defaultStartDate]="marOptions.StartDate"
                                    [defaultEndDate]="marOptions.EndDate"
                                    (selectedChange)="selectEffectiveDate($event)"
                                    (errorState)="dateRangeError($event)"
                                    [maxNumberOfDays]="getMaximumNumberOfDays()"
                            ></my-date-range-selector>
                            <div class="dateError">
                                {{dateRangeErrorText}}
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="2">
                        <div class="row">
                            <span class="modal-sub-header">Select Nursing Stations: <span
                                    class="modal-sub-header" style="margin-left: 10px;"><a (click)="selectAllNursingStations()">Select All</a></span></span>

                            <div *ngFor="let nursingStation of marOptions.NursingStations">
                                <label [class]="isAllNSSelected ? 'checkbox-square' : 'checkbox'"><input type="checkbox" (change)="selectNursingStation()" [(ngModel)]="nursingStation.IsSelected"><span></span><span class="checkbox-label">
                                    {{nursingStation.NursingStationName}}</span>
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <span class="modal-sub-header">Admission Date Range (optional):</span><br>
                            <my-date-range-selector
                                    [allowBlanks]="true"
                                    [skipDataStore]="true"
                                    (selectedChange)="selectAdmissionsDate($event)"
                                    [defaultStartDate]="admissionStartDate"
                                    [defaultEndDate]="admissionEndDate"
                            ></my-date-range-selector>
                        </div>
                    </div>
                    <div *ngSwitchCase="3">
                        <div class="row">
                            <span class="modal-sub-header">Select Residents: <a (click)="selectAllResidents()">Select All</a></span>
                            <span style="float: right; margin-left: 10px;">{{selectedResidentCount}} selected</span>
                            <div>
                                <input type="search" [(ngModel)]="searchText" (ngModelChange)="searchResidents($event)" placeholder="Search" style="width: 330px; margin-bottom: 10px">
                            </div>
                            <div class="resident-content-area">
                                <div *ngFor="let resident of filteredResidents">
                                    <label [class]="isAllResidentsSelected ? 'checkbox-square' : 'checkbox'"><input type="checkbox" (ngModelChange)="selectResident()" [(ngModel)]="resident.IsSelected"><span></span><span  class="checkbox-label">
                                        {{resident.Name}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <span class="modal-sub-header">Sort by:</span>

                            <div *ngFor="let sortOrder of sortOrderEnums">
                                <label class="radio {{selectedResidentCount <= 1 ? 'disabled' : '' }}">
                                    <input type="radio" [disabled]="selectedResidentCount <= 1" name="sortBy" (change)="selectSortOrder(sortOrder)" [(ngModel)]="marOptions.sortOrder" [value]="sortOrder"><span></span>
                                    {{getDisplayNameForEnum(sortOrder)}}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchDefault>
                        <div class="row">
                            <span class="modal-sub-header">Select records to include: <span class="modal-sub-header" style="margin-left: 10px;"><a>Select All</a></span></span>
                            <div>
                                <label class="checkbox"><input type="checkbox"><span></span><span class="checkbox-label">
                                    Medical Administration Record (MAR)</span>
                                </label>
                            </div>
                            <div>
                                <label class="checkbox"><input type="checkbox"><span></span>
                                    <span class="checkbox-label">Treatment Authorization Request (TAR) </span>
                                </label>
                            </div>
                            <div>
                                <label class="checkbox"><input type="checkbox"><span></span><span class="checkbox-label">
                                    Physician Order Sheet (POS)</span>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <span class="modal-sub-header">Options:</span>
                            <div>
                                <label class="checkbox"><input type="checkbox"><span></span><span class="checkbox-label">
                                    Include Non-Med Orders</span>
                                </label>
                            </div>
                            <div>
                                <label class="checkbox"><input type="checkbox"><span></span><span class="checkbox-label">
                                    Include As Needed (PRN) Orders</span>
                                </label>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <span class="modal-sub-header">Effective Date Range:</span><br>
                            <my-date-range-selector></my-date-range-selector>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left" *ngIf="screen == 1">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-left text-align-left" *ngIf="screen != 1">
                    <button class="btn btn-primary" (click)="setScreen(screen - 1)">Back</button>
                </div>
                <div class="float-right text-align-right">

                    <div [ngSwitch]="screen">
                        <button *ngSwitchCase="1" class="btn btn-primary" (click)="stepOne()" [disabled]="marOptions.MedicalRecord === noneValue || dateRangeErrorText">Next: Select Nursing Stations</button>
                        <button *ngSwitchCase="2" class="btn btn-primary" [disabled]="!selectedNursingStation" (click)="stepTwo()">Next: Select Residents</button>
                        <button *ngSwitchCase="3" (click)="generatePDF()" [disabled]="selectedResidentCount <= 0 || !hideSpinner" class="btn btn-primary">
                            <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner"> Finished: View {{version}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>